import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"transition":"dialog-top-transition","fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogAutorizacao),callback:function ($$v) {_vm.dialogAutorizacao=$$v},expression:"dialogAutorizacao"}},[_c(VCard,{staticClass:"autorizacao-top-bar"},[_c(VToolbar,{attrs:{"dark":"","color":"#042333","height":"56px"}},[_c(VBtn,{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.setDialogAutorizacao(false)}}},[_c(VIcon,[_vm._v("mdi-close")])],1),_c(VToolbarTitle,[_vm._v("Workflow de compras")])],1),_c('autorizacao')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }